import _implicitStylesheets from "./securityReviewFalsePositives.css";
import _implicitScopedStylesheets from "./securityReviewFalsePositives.scoped.css?scoped=true";
import _appxImageUploader from "appx/imageUploader";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="slds-m-bottom--medium title${0}"${2}>${"t1"}</div>`;
const $fragment2 = parseFragment`<span class="slds-checkbox_faux${0}"${2}></span>`;
const $fragment3 = parseFragment`<label class="slds-checkbox__label${0}"${"a0:for"}${2}><span class="slds-checkbox_faux${0}"${2}></span><span class="slds-form-element__label slds-m-left--medium body-2-text${0}"${2}>${"t3"}</span></label>`;
const $fragment4 = parseFragment`<div class="slds-m-left_x-large slds-m-bottom_meduim slds-p-top_medium upload-documents body-2-text required${0}"${2}>${"t1"}</div>`;
const stc0 = {
  classMap: {
    "failed-state": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "submitted-titles": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "false-positive": true,
    "slds-list_horizontal": true,
    "slds-m-bottom_meduim": true
  },
  key: 4
};
const stc3 = {
  classMap: {
    "checkbox": true,
    "slds-checkbox": true,
    "slds-checkbox_standalone": true
  },
  key: 5
};
const stc4 = {
  classMap: {
    "slds-m-left_x-large": true
  },
  key: 13
};
const stc5 = {
  "data-test-id": "failed-submission"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, gid: api_scoped_id, b: api_bind, h: api_element, c: api_custom_element} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, [api_element("div", stc1, [api_static_fragment($fragment1, 3, [api_static_part(1, null, api_dynamic_text($cmp.labels.falsePositiveDocs))]), api_element("div", stc2, [api_element("span", stc3, [api_element("input", {
    attrs: {
      "type": "checkbox",
      "id": api_scoped_id("false-positive-doc"),
      "name": "false-positive-doc",
      "aria-label": "hasFalsePositiveDoc"
    },
    props: {
      "value": $cmp.showFalsePositivesUpload,
      "checked": $cmp.showFalsePositivesUpload
    },
    key: 6,
    on: {
      "change": _m0 || ($ctx._m0 = api_bind($cmp.onChangeHasFalsePositiveDocs))
    }
  }), api_static_fragment($fragment2, 8)]), api_static_fragment($fragment3, 10, [api_static_part(0, {
    attrs: {
      "for": api_scoped_id("false-positive-doc")
    }
  }, null), api_static_part(3, null, api_dynamic_text($cmp.labels.vulnerabilitiesCheckbox))])]), $cmp.showFalsePositivesUpload ? api_static_fragment($fragment4, 12, [api_static_part(1, null, api_dynamic_text($cmp.labels.uploadDocumentation))]) : null, $cmp.showFalsePositivesUpload ? api_element("div", stc4, [api_custom_element("appx-image-uploader", _appxImageUploader, {
    attrs: stc5,
    props: {
      "variant": "slim",
      "ariaLabel": $cmp.labels.ariaLabel,
      "supportedFormats": $cmp.supportedFormats,
      "uploadStarted": $cmp.uploadStarted,
      "uploadFailed": $cmp.uploadFailed,
      "changeUrl": $cmp.onChangeFile,
      "successMessage": $cmp.successUploadFileMessage,
      "tooLargeErrorMessage": $cmp.tooLargeUploadFileMessage,
      "uploadFailedMessage": $cmp.failedUploadFileMessage,
      "maxAssetUploadSize": $cmp.maxAssetUploadSize,
      "useSecureStorage": true,
      "objectName": $cmp.solutionName,
      "previewImageUrl": $cmp.falsePositiveDoc.fileName
    },
    key: 14
  })]) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1c7soi1gikd";
tmpl.legacyStylesheetToken = "appx-securityReviewFalsePositives_securityReviewFalsePositives";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
